<script>
import { BButtonGroup } from "bootstrap-vue";

export default {
  extends: BButtonGroup
};
</script>